import React, { Component } from "react";
import withNavbar from "../../common/HOC/NavbarContainerHOC";
import {
  convertJsonToQueryString,
  queryStringToJSON
} from "../../../helpers/NewCaHelper";
import { History, Location } from "history";
import { match } from "react-router";
import SearchButton from "../../common/button/SearchButton";
import InputWithLabel from "../../common/form/InputWithLabel";
import Helmet from "react-helmet";
import { Type } from "./AgencyEnum";
import AgencyService from "../../../services/agency/AgencyService";
import SelectBox from "../../common/form/SelectBox";
import UserService from "../../../services/user/UserService";
import SelectUserManager from "../../common/form/SelectUserManager";
import AgencyTable from "./table/AgencyTable";

interface Props {
  history: History;
  location: Location;
  match: match;
  name:string;
  userManager: object;
  user: any;
}
interface State {
  dataSearch: any;
}

const TITLE = 'Danh sách đại lý';
class PageIndex extends Component<Props, State> {
  state = {
    dataSearch: {
      text_search: "",
      status: "",
      tax_code: "",
      sale_id : ""
    },
    userManager: {}
  };

   fetchDataFunction = async (dataSearch = {})=>{
    const service = new AgencyService();
    const result = await service.getAgencys(
        {...dataSearch},
      );

    if(result && result.status===200){
      return result
    }
    return null;
  }

  onChangeDataSearchInput = e => {
    const name = e.target.name;
    const value = e.target.value;
    const dataSearch = { ...this.state.dataSearch, [name]: value };
    this.setState({ dataSearch });
  };
  onChangeDataSearchSale_Id = (e) => {
    const dataSearch = { ...this.state.dataSearch, 'sale_id': e };
    this.setState({ dataSearch });
  };

  onChangeDataSearchStatus = (e) => {
    const dataSearch = { ...this.state.dataSearch, 'status': e };
    this.setState({ dataSearch });
  };

  onSubmitSearchButton = async e => {
    e.preventDefault();
    let { dataSearch } = this.state;
    const queryString = convertJsonToQueryString(dataSearch);
    this.props.history.push({
      pathname: this.props.match.url,
      search: queryString
    });
  };

  onClickUpdateButton = (data) =>{
    this.props.history.push(`${this.props.match.url}/cap-nhat/${data.id}`);
  }

  componentDidMount() {
    this.getUserManager();
    const queryString = queryStringToJSON(this.props.location.search);
    this.setState({
      dataSearch:queryString
    })
  }

  getUserManager = async () => {
    const service = new UserService();
    const result = await service.getUserByType(5);
    if(result && result.status===200){
      this.setState({
        userManager: result.data
      } as any);
    }
  }

  onRenderStatusColumn(type) {
    return (
      <label className={`badge ${Type.badgeClass[type]}`}>
        {Type.STATUS[type]}
      </label>
    );
  }

  render() {
    return (
      <div className="card">
        <Helmet>
          <title>{TITLE}</title>
        </Helmet>
        <h4 className="card-title1">{TITLE}</h4>
        <div className="card-body">
          <form onSubmit={this.onSubmitSearchButton} className='search-form-index'>
            <div className="input-group">
                <SelectUserManager
                  label="Người quản lý"
                  onChange={this.onChangeDataSearchSale_Id}
                  value={this.state.dataSearch.sale_id}
                  name="sale_id"
                  wrappedClass="col-md-2 form-group nopadding-left"
                  options={this.state.userManager}
                  firstOptionLabel="Người quản lý"
                />
              <SelectBox
                  value={this.state.dataSearch.status}
                  label=""
                  onChange={this.onChangeDataSearchStatus}
                  name="status"
                  wrappedClass="col-md-2 form-group nopadding-left"
                  options={Type.STATUS}
                  firstOptionLabel="Trạng thái"
                />
              <InputWithLabel
                name="tax_code"
                wrapClass="col-md-2 form-group nopadding-left"
                onChangeValue={this.onChangeDataSearchInput}
                value={this.state.dataSearch.tax_code}
                isRequired={false}
                label={""}
                placeholder={"Mã số thuế"}
              />
              <InputWithLabel
                name="text_search"
                wrapClass="col-md-3 form-group nopadding-left"
                onChangeValue={this.onChangeDataSearchInput}
                value={this.state.dataSearch.text_search}
                isRequired={false}
                placeholder={"Mã hoặc tên đại lý"}
                label={""}
              />
              <div className="col-md-3 form-group nopadding-left">
                <SearchButton onClick={this.onSubmitSearchButton} />
              </div>
            </div>
          </form>
          <AgencyTable
            location={this.props.location}
            history={this.props.history}
            match={this.props.match}
            user={this.props.user}
          />
        </div>
      </div>
    );
  }
}

const pageWithNavBar = withNavbar()(PageIndex);

export default pageWithNavBar;
